// extracted by mini-css-extract-plugin
module.exports = {"root":"InputNumber__root--3Vb4i","button":"InputNumber__button--1rmNy","input":"InputNumber__input--3NACe"};